import React, {FC, ReactNode} from 'react';
import {Popup} from '../Popup';
import styles from './Dialog.css';

interface DialogProps {
	title?: string;
	onClose(): void;
	children: ReactNode;
}

export const Dialog: FC<DialogProps> = props => {
	const {title, onClose, children} = props;

	return (
		<div className={styles.container}>
			<Popup className={styles.main} title={title} onClose={onClose}>
				{children}
			</Popup>
		</div>
	);
};

Dialog.displayName = 'Dialog';
